import React, { useContext, useEffect, useState, useRef } from "react";
import ImageContainer from "../ImageContainer";
import ImagesTable from "../ImagesTable";
import { Images_Template } from "../../Data/Data";
import ImagesFilters from "./ImagesFilters";
import Popup from "reactjs-popup";
import TadobaContext from "../Context/TadobaContext";
import { makeRequest } from "../../api";
import { toast } from "react-toastify";
import { warningToaster } from "../../Data/Data";
import FilterDetails from "../FilterDetails";
import ImageEdit from "./ImageEdit";
import EditMultipleImages from "./EditMultipleImages";

const AllImages = (props) => {
  const [species, setSpecies] = useState([]);
  const [filter_years, setYears] = useState([]);
  const api = useContext(TadobaContext);
  const [filter, setFilter] = useState(false);
  const [count, setCount] = useState(0);
  const [render, setRender] = useState(1);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [scroll, setScroll] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [grid, stGrid] = useState(true);
  const [listData, setListData] = useState([]);
  const [exportedImages, setExportedImages] = useState([]);
  const [speciesData, setSpeciesData] = useState([]);
  const [filterSpecies, setFilterSpecies] = useState([]);
  const [allCheck, setAllCheck] = useState(false);
  const [exportedIds, setExportedIds] = useState([]);
  const [downloadXl, setDownloadXl] = useState("0");
  const [selectedOption, setSelectedOption] = useState("");
  const [deletedImageList, setDeletedImageList] = useState([]);
  const prevStartDeleteRef = useRef(api.startDelete);
  const [customTimeRange, setCustomTimeRage] = useState({});

  const [filtersArray, setFiltersArray] = useState([]);
  const [isEditImgOpen, setIsEditImgOpen] = useState(false);
  const [imageEditId, setImageEditId] = useState("");
  const imgContainerRef = useRef();

  const resetRefs = () => {
    if (imgContainerRef.current) {
      imgContainerRef.current.resetStates(); 
    }
  };

  useEffect(() => {
    if (render === 1) {
      api.setFilterQuery([]);
      setYears([]);
      api.setYearsData([]);
      setFilterSpecies([]);
      api.setImagesFilters([]);
    }
    getImages();
  }, [render, page]);

  useEffect(() => {
    const fetchSpeciesData = async () => {
      try {
        const response = await makeRequest("get", `api/v1/species/species/`);
        setSpeciesData(response.data.data);
      } catch (error) {
        console.error("Error fetching species data:", error);
      }
    };

    if (!localStorage.species) {
      fetchSpeciesData();
    } else {
      const storedData = JSON.parse(localStorage.species);
      setSpeciesData(storedData);
    }
  }, []);


  const getImages = async () => {
    if (filter === true) {
      filterApply();
      return;
    }
    setScroll(true);
    if (page <= currentPage) {
      setLoading(false);
      return;
    }
    let token = "";
    try {
      if (localStorage.token) {
        token = localStorage.token;
      }
      const result = await makeRequest(
        "get",
        `api/v1/classification/image_list/?page=${page}&size=20`
      );
      const tempData = result.data.data;
      const newData = tempData.map((row, key) => {
        const obj = { ...row };
        obj.checked = false;
        return obj;
      });
      setCount(result.data.count);

      if (newData.length === 0) {
      } else {
        const formattedList = [];

        for (const cameraData of newData) {
          const name = cameraData?.id;
          const species = cameraData?.species?.name;
          const dateString = cameraData.captured_at;
          const dateObj = new Date(dateString);
          const options = {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: true,
            timeZone: "UTC",
          };

          const formattedDate = new Intl.DateTimeFormat(
            "en-US",
            options
          ).format(dateObj);

          let checked = false;
          if (allCheck) {
            checked = true;
          }
          const formattedData = {
            Name: name || "Name not avilable",
            Species: species || "Unclassified",
            "Station ID": cameraData.station.name.toString(),
            "Camera ID": cameraData.camera.name.toString(),
            Range: cameraData.range.name.toString(),
            tiger_name: cameraData?.specie_sub_type?.name,
            "Date and Time": formattedDate,
            image: cameraData.image,
            checked: checked,
            id: cameraData.id,
          };
          formattedList.push(formattedData);
        }
        setListData((prevData) => [...prevData, ...formattedList]);
        setCurrentPage(currentPage + 1);
        setLoading(false);
        setScroll(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const deleteImage = async (array, close) => {
    let array_data = array;
    setDeletedImageList(array_data);
    const data = api.filterQuery;

    const geolocationRange = [];
    const geolocationRound = [];
    const geolocationBeat = [];
    const geolocationCompartment = [];
    const geolocationStation = [];
    const geolocationCamera = [];
    const size = 20;

    for (const entry of Object.values(data)) {
      const [key, value] = entry.split("=");
      if (key === "range_name") {
        geolocationRange.push(value);
      } else if (key === "round_name") {
        geolocationRound.push(value);
      } else if (key === "beat_name") {
        geolocationBeat.push(value);
      } else if (key === "compartment_name") {
        geolocationCompartment.push(value);
      } else if (key === "station_name") {
        geolocationStation.push(value);
      } else if (key === "camera_name") {
        geolocationCamera.push(parseInt(value));
      }
    }
    const result_data = {
      geolocation_range: geolocationRange,
      geolocation_round: geolocationRound,
      geolocation_beat: geolocationBeat,
      geolocation_compartment: geolocationCompartment,
      geolocation_station: geolocationStation,
      geolocation_camera: geolocationCamera,
      species: species,
      years: filter_years,
      start_date: customTimeRange?.start_date,
      end_date: customTimeRange?.end_date,
    };
    let token = "";

    try {
      if (localStorage.token) {
        token = localStorage.token;
      }
      let data = {};
      if (allCheck) {
        data = {
          image_ids: [],
          filters: result_data,
        };
      } else if (exportedIds.length > 0) {
        data = {
          image_ids: exportedIds,
          filters: result_data,
        };
      } else {
        data = {
          image_ids: array_data,
          filters: result_data,
        };
      }
      if (allCheck || exportedIds.length > 0 || array_data.length > 0) {
        let displayCount;

        if (allCheck) {
          displayCount = count;
        } else if (exportedIds.length > 0) {
          displayCount = exportedIds.length;
        } else if (array_data.length > 0) {
          displayCount = array_data.length;
        }
        const finalCount = Math.min(displayCount, 5000);
        if (finalCount >= 5000) {
          toast.success("Delete Limit - 5000 Images", warningToaster);
          api.setStartDelete(false);
          return;
        }
        api.setDownloadingText(`Deleting ${finalCount} Images....`);
        localStorage.setItem("text", `Deleting ${finalCount} Images....`);
      }
      api.setStartDelete(true);
      api.setDeleteQuery(data);
      api.setDisable(true);

      close();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (prevStartDeleteRef.current === true && api.startDelete === false) {
      setListData((prevListData) =>
        prevListData.filter((item) => !deletedImageList.includes(item.id))
      );
      api.setDeleteQuery([]);
      setAllCheck(false);
      setExportedIds([]);
    }
    prevStartDeleteRef.current = api.startDelete;
  }, [api.startDelete]);

  const downloadAllImages = async () => {
    api.setStartDownload(true);
    api.setDisable(true);
    localStorage.setItem("disable", true);
    const data = api.filterQuery;
    const geolocationRange = [];
    const geolocationRound = [];
    const geolocationBeat = [];
    const geolocationCompartment = [];
    const geolocationStation = [];
    const geolocationCamera = [];

    for (const entry of Object.values(data)) {
      const [key, value] = entry.split("=");
      if (key === "range_name") {
        geolocationRange.push(value);
      } else if (key === "round_name") {
        geolocationRound.push(value);
      } else if (key === "beat_name") {
        geolocationBeat.push(value);
      } else if (key === "compartment_name") {
        geolocationCompartment.push(value);
      } else if (key === "station_name") {
        geolocationStation.push(value);
      } else if (key === "camera_name") {
        geolocationCamera.push(parseInt(value));
      }
    }
    const result_data = {
      geolocation_range: geolocationRange,
      geolocation_round: geolocationRound,
      geolocation_beat: geolocationBeat,
      geolocation_compartment: geolocationCompartment,
      geolocation_station: geolocationStation,
      geolocation_camera: geolocationCamera,
      species: species,
      years: filter_years,
      start_date: customTimeRange?.start_date,
      end_date: customTimeRange?.end_date,
    };
    let token = "";
    try {
      if (localStorage.token) {
        token = localStorage.token;
      }
      let data = {};
      if (allCheck) {
        data = {
          image_ids: ["all"],
          specie_id: "",
          camera_id: "",
          download_xl: downloadXl,
          filters: result_data,
        };
      }
      if (exportedIds.length > 0) {
        data = {
          image_ids: exportedIds,
          specie_id: "",
          camera_id: "",
          download_xl: downloadXl,
          filters: result_data,
        };
      } else {
      }
      if ((allCheck || exportedIds.length > 0) && downloadXl === "0") {
        const displayCount = allCheck ? count : exportedIds.length;
        const finalCount = Math.min(displayCount, 5000);
        if (finalCount >= 5000) {
          toast.success("Download Limit - 5000 Images", warningToaster);
          api.setStartDownload(false);
          localStorage.setItem("disable", false);
          api.setDisable(false);
          return;
        }
        api.setDownloadingText(`Downloading ${finalCount} Images....`);
        localStorage.setItem("text", `Downloading ${finalCount} Images....`);
      }
      if (downloadXl === "1") {
        api.setDownloadingText(`Downloading Excel File....`);
        localStorage.setItem("text", `Downloading Excel File....`);
      }
      api.setDownloadQuery(data);
      setDownloadXl("0");
    } catch (error) {
      console.error("Failed to create download link:", error);
      api.setDownloadingText("");
      api.setStartDownload(false);
      localStorage.setItem("disable", false);
      api.setDisable(false);
    }
  };
  const filterApply = async (close) => {
    setFilter(true);
    const data = api.filterQuery;
    const geolocationRange = [];
    const geolocationRound = [];
    const geolocationBeat = [];
    const geolocationCompartment = [];
    const geolocationStation = [];
    const geolocationCamera = [];
    const size = 20;
    for (const entry of Object.values(data)) {
      const [key, value] = entry.split("=");
      if (key === "range_name") {
        geolocationRange.push(value);
      } else if (key === "round_name") {
        geolocationRound.push(value);
      } else if (key === "beat_name") {
        geolocationBeat.push(value);
      } else if (key === "compartment_name") {
        geolocationCompartment.push(value);
      } else if (key === "station_name") {
        geolocationStation.push(value);
      } else if (key === "camera_name") {
        geolocationCamera.push(parseInt(value));
      }
    }
    const result_data = {
      geolocation_range: geolocationRange,
      geolocation_round: geolocationRound,
      geolocation_beat: geolocationBeat,
      geolocation_compartment: geolocationCompartment,
      geolocation_station: geolocationStation,
      geolocation_camera: geolocationCamera,
      species: species,
      years: filter_years,
      page: page,
      size: size,
      start_date: customTimeRange?.start_date,
      end_date: customTimeRange?.end_date,
    };

    setScroll(true);
    if (page <= currentPage) {
      setLoading(false);
      return;
    }
    let token = "";
    try {
      if (localStorage.token) {
        token = localStorage.token;
      }
      const result = await makeRequest(
        "post",
        `api/v1/classification/image_filter/`,
        result_data
      );
      const tempData = result.data.data;
      const newData = tempData.map((row, key) => {
        const obj = { ...row };
        obj.checked = false;
        return obj;
      });
      setCount(result.data.count);
      const speciesIds = result_data.species;
      const matchedSpeciesNames = speciesIds
        .map((speciesId) => {
          const matchedSpecies = speciesData.find(
            (speciesEntry) => speciesEntry.id === speciesId
          );
          return matchedSpecies ? matchedSpecies.name : null;
        })
        .filter((name) => name !== null);
      setFilterSpecies(matchedSpeciesNames);

      if (newData.length === 0) {
      } else {
        const formattedList = [];

        for (const cameraData of newData) {
          const name = cameraData?.id;
          const species = cameraData?.species?.name;
          const tiger_name = cameraData?.specie_sub_type?.name;
          const dateString = cameraData.captured_at;
          const dateObj = new Date(dateString);
          const options = {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: true,
            timeZone: "UTC",
          };

          const formattedDate = new Intl.DateTimeFormat(
            "en-US",
            options
          ).format(dateObj);
          let checked = false;
          if (allCheck) {
            checked = true;
          }

          const formattedData = {
            Name: name,
            Species: species || "Unclassified",
            "Station ID": cameraData.station.name.toString(),
            "Camera ID": cameraData.camera.name.toString(),
            "Date and Time": formattedDate,
            tiger_name: cameraData?.specie_sub_type?.name,
            Range: cameraData.range.name,
            image: cameraData.image,
            checked: checked,
            id: cameraData.id,
          };
          formattedList.push(formattedData);
        }
        setListData((prevData) => [...prevData, ...formattedList]);
        setCurrentPage(currentPage + 1);
        setLoading(false);
        setScroll(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (exportedImages.length !== 0 || allCheck) {
      api.setDisable(false);
    } else {
      api.setDisable(true);
    }
  }, [exportedImages, allCheck]);

  const editImage = (value) => {
    setImageEditId(value.id);
    setIsEditImgOpen(true);
  };

  const closeEditImgPopup = () => setIsEditImgOpen(false);

  const clearFilter = () => {
    setFilterSpecies([]);
    setYears([]);
  };

  function handleExportOption(event) {
    const option = event.target.value;

    switch (option) {
      case "excel":
        setDownloadXl("1");
        break;
      case "images":
        downloadAllImages();
        break;
      default:
        console.log("No action for this option");
    }
    setSelectedOption("");
  }
  useEffect(() => {
    if (downloadXl === "1") {
      downloadAllImages();
    }
  }, [downloadXl]);

  return (
    <div className="Setting_User">
      <div className="Setting_User_Header">
        <div className="Images_Filter_Container">
          <span>Images</span>
          <div className="Filter_Species_Display">
            {filterSpecies.length > 0 && <span>(</span>}
            {filterSpecies.slice(0, 3).map((speciesName, index) => (
              <React.Fragment key={index}>
                {index > 0 && <span>, </span>}
                <span>{speciesName}</span>
              </React.Fragment>
            ))}
            {filterSpecies.length > 3 && <span>, ...</span>}
            {filterSpecies.length > 0 && <span>)</span>}
          </div>
          <div className="Filter_Species_Display">
            {filter_years.length > 0 && <span>(</span>}
            {filter_years.slice(0, 3).map((year, index) => (
              <React.Fragment key={index}>
                {index > 0 && <span>, </span>}
                <span>{year}</span>
              </React.Fragment>
            ))}
            {filter_years.length > 3 && <span>, ...</span>}
            {filter_years.length > 0 && <span>)</span>}
            {customTimeRange?.start_date && customTimeRange?.end_date && (
              <span>
                {customTimeRange?.start_date} - {customTimeRange?.end_date}
              </span>
            )}
          </div>
          <div className="Filter_Species_Display">
            <FilterDetails filtersArray={filtersArray} />
          </div>
        </div>

        <div className="Setting_User_Attribute">
          {exportedImages.length > 1 && (
              <EditMultipleImages
                getImages={getImages}
                exportedIds={exportedIds}
                onReset={resetRefs}
                setExportedImages={setExportedImages}
                setExportedIds={setExportedIds}
                allImages={true}
                groupTiger={false}
                species={species}
                listData={listData}
                setListData={setListData}
              />
          )}
          <Popup
            trigger={
              <div className="role_filter">
                <img src={require("../../Assets/Icons/filter.png")} alt="" />
                {filterSpecies.length > 0 && (
                  <span className="filter_count"></span>
                )}
              </div>
            }
            modal
            nested
          >
            {(close) => (
              <ImagesFilters
                species={species}
                setFilter={setFilter}
                setRender={setRender}
                render={render}
                close={close}
                setLoading={setLoading}
                setCurrentPage={setCurrentPage}
                setListData={setListData}
                setPage={setPage}
                filterApply={filterApply}
                setSpecies={setSpecies}
                clearFilter={clearFilter}
                years={filter_years}
                setYears={setYears}
                type={"all images"}
                setFiltersArray={setFiltersArray}
                customRange={customTimeRange}
                setCustomRange={setCustomTimeRage}
              />
            )}
          </Popup>

          <div className={`role_filter ${api.disable ? "disabled" : ""}`}>
            <select
              onChange={handleExportOption}
              disabled={api.disable}
              value={selectedOption}
            >
              <option value="" disabled hidden>
                Export
              </option>
              <option value="excel">As Excel</option>
              <option value="images">As Images</option>
            </select>
          </div>
        </div>
      </div>
      {grid ? (
        <div style={{ position: "relative" }}>
          <ImageContainer
            exportedImages={exportedImages}
            scroll={scroll}
            setExportedImages={setExportedImages}
            currentPage={currentPage}
            grid={grid}
            setGrid={stGrid}
            setCurrentPage={setCurrentPage}
            page={page}
            setPage={setPage}
            count={count}
            setData={setListData}
            data={listData}
            getImages={getImages}
            deleteImage={deleteImage}
            editImage={editImage}
            type={"Classified"}
            loading={loading}
            setAllCheck={setAllCheck}
            setExportedIds={setExportedIds}
            name={"All Images"}
            ref={imgContainerRef}
            hoverRevert={false}
          />
        </div>
      ) : (
        <ImagesTable
          exportedImages={exportedImages}
          scroll={scroll}
          setExportedImages={setExportedImages}
          currentPage={currentPage}
          grid={grid}
          setGrid={stGrid}
          delete={true}
          setCurrentPage={setCurrentPage}
          page={page}
          setPage={setPage}
          setData={setListData}
          count={count}
          data={listData}
          getImages={getImages}
          deleteImage={deleteImage}
          editImage={editImage}
          type={"Classified"}
          template={Images_Template}
          loading={loading}
          setAllCheck={setAllCheck}
          setExportedIds={setExportedIds}
        />
      )}
      <Popup
        open={isEditImgOpen}
        onClose={closeEditImgPopup}
        modal
        closeOnDocumentClick={false}
      >
        <ImageEdit closeEditImgPopup={closeEditImgPopup} id={imageEditId} />
      </Popup>
    </div>
  );
};

export default AllImages;
